export default {
  Ph: "allowCrawlerActivity",
  Wh: "baseUrl",
  Vh: "noCookies",
  Kh: "devicePropertyAllowlist",
  La: "disablePushTokenMaintenance",
  $h: "enableLogging",
  Yh: "enableSdkAuthentication",
  Ka: "manageServiceWorkerExternally",
  Xh: "minimumIntervalBetweenTriggerActionsInSeconds",
  Zh: "sessionTimeoutInSeconds",
  Qh: "appVersion",
  Xa: "appVersionNumber",
  Ga: "serviceWorkerLocation",
  Ia: "safariWebsitePushId",
  Wa: "localization",
  er: "contentSecurityNonce",
  te: "allowUserSuppliedJavascript",
  $a: "inAppMessageZIndex",
  Ja: "openInAppMessagesInNewTab",
  Oh: "requireExplicitInAppMessageDismissal",
  Za: "doNotLoadFontAwesome",
  tl: "deviceId",
  Ha: "serviceWorkerScope",
  Ne: "dustHost",
  il: "sdkFlavor",
  tn: "openCardsInNewTab",
};
